import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/69cfb1e334b9ae00142825d1/fajrulportfolio/node_modules/next/dist/client/app-dir/link.js");
